const TIMELINE_FACTS = [
  ["signed", "signed_date"],
  ["issued", "issued_date"],
  ["gazette", "gazette_date"],
  ["effective", "effective_date"],
  ["page-updated", "page_updated_date"],
];

const TIMELINE_LABELS = {
  th: {
    signed: "ลงนาม",
    issued: "ออกเอกสาร",
    gazette: "ประกาศราชกิจจานุเบกษา",
    effective: "วันที่มีผลใช้บังคับที่บันทึก",
    "page-updated": "วันที่ปรับปรุงหน้าเผยแพร่",
  },
  en: {
    signed: "Signed",
    issued: "Issued",
    gazette: "Gazette publication",
    effective: "Recorded effective date",
    "page-updated": "Published-page update",
  },
};

/**
 * Legal dates are valid-time facts. System timestamps such as `updated_at`
 * describe our record, not a publisher's page, so they are deliberately not
 * eligible for the reader timeline.
 */
export function legalTimelineFacts(document = {}, locale = "th") {
  const labels = TIMELINE_LABELS[locale] || TIMELINE_LABELS.th;
  return TIMELINE_FACTS.map(([kind, field]) => ({
    label: labels[kind],
    kind,
    field,
    value: document[field] || null,
  }));
}

export function formatTimelineDate(value, locale = "th") {
  if (!value) return "";
  const raw = String(value);
  // Only canonical legal dates are dates. A document number such as 145 is not
  // a year, and Date's rollover must not turn an impossible day into another.
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  const date = new Date(`${raw}T00:00:00Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== raw) return raw;
  return date.toLocaleDateString(
    locale === "en" ? "en-GB" : "th-TH-u-ca-buddhist",
    { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" },
  );
}
